// extracted by mini-css-extract-plugin
module.exports = {"pause":"_3Q37zz2VeCBGaORQNv6NKa"};